/**
 * Restructures Hulk Quick Quote product fields into boxed specs sections
 * matching the theme contact-form custom_inputs layout.
 *
 * Paste into Hulk: Form Settings → Advanced → Custom JavaScript
 * (or load from theme on pages where the iframe is same-origin).
 */
(function () {
  var FORM_UUID = 'v4NWEWgqeEEeMNsxDhQLDQ';
  var PRODUCT_SECTIONS = [
    { start: 9, dims: [10, 11, 12, 13, 14, 15], meta: [16, 17, 18], notes: 19 },
    { start: 21, dims: [22, 23, 24, 25, 26, 27], meta: [28, 29, 30], notes: 31 },
    { start: 33, dims: [34, 35, 36, 37, 38, 39], meta: [40, 41, 42], notes: 43 },
    { start: 45, dims: [46, 47, 48, 49, 50, 51], meta: [52, 53, 54], notes: 55 },
    { start: 57, dims: [58, 59, 60, 61, 62, 63], meta: [64, 65, 66], notes: 67 }
  ];

  function getFormRoot(doc) {
    return doc.querySelector('.hulk_form_' + FORM_UUID) || doc.getElementById('wizard-validation-form');
  }

  function wrapProductSections(doc) {
    var root = getFormRoot(doc);
    if (!root || root.dataset.qqSpecsWrapped === 'true') return;

    var container = root.querySelector('.form_container');
    if (!container) return;

    PRODUCT_SECTIONS.forEach(function (section) {
      var box = doc.createElement('div');
      box.className = 'hulk-qq-specs';

      var dims = doc.createElement('div');
      dims.className = 'hulk-qq-specs__dims';

      var dimGroups = [
        section.dims.slice(0, 2),
        section.dims.slice(2, 4),
        section.dims.slice(4, 6)
      ];

      dimGroups.forEach(function (pair) {
        var group = doc.createElement('div');
        group.className = 'hulk-qq-specs__dim-group';
        pair.forEach(function (index) {
          var el = container.querySelector('.formElement_' + index);
          if (el) group.appendChild(el);
        });
        if (group.children.length) dims.appendChild(group);
      });

      if (dims.children.length) box.appendChild(dims);

      var meta = doc.createElement('div');
      meta.className = 'hulk-qq-specs__meta';
      section.meta.forEach(function (index) {
        var el = container.querySelector('.formElement_' + index);
        if (el) meta.appendChild(el);
      });
      if (meta.children.length) box.appendChild(meta);

      var notesEl = container.querySelector('.formElement_' + section.notes);
      if (notesEl) {
        var notes = doc.createElement('div');
        notes.className = 'hulk-qq-specs__notes';
        notes.appendChild(notesEl);
        box.appendChild(notes);
      }

      var anchor = container.querySelector('.formElement_' + section.start);
      if (anchor) {
        anchor.parentNode.insertBefore(box, anchor);
        anchor.remove();
      } else if (box.children.length) {
        container.appendChild(box);
      }
    });

    root.dataset.qqSpecsWrapped = 'true';

    if (typeof window.iframe_resize === 'function') {
      window.iframe_resize('no', 'no', 'initial');
    }
  }

  function initInDocument(doc) {
    if (!getFormRoot(doc)) return;
    wrapProductSections(doc);
  }

  function init() {
    initInDocument(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Parent-page helper: inject CSS/JS into Hulk iframe when accessible */
  if (window.self !== window.top) return;

  var HULK_FORM_ID = FORM_UUID;
  var CSS_URL = (function () {
    var link = document.querySelector('link[href*="hulk-quick-quote-form.css"]');
    return link ? link.href : null;
  })();
  var JS_URL = (function () {
    var script = document.querySelector('script[src*="hulk-quick-quote-form.js"]');
    return script ? script.src : null;
  })();

  function injectIntoIframe(iframe) {
    var doc;
    try {
      doc = iframe.contentDocument || iframe.contentWindow.document;
    } catch (e) {
      return false;
    }
    if (!doc || !getFormRoot(doc)) return false;

    if (CSS_URL && !doc.querySelector('link[data-hulk-qq-css]')) {
      var styleLink = doc.createElement('link');
      styleLink.rel = 'stylesheet';
      styleLink.href = CSS_URL;
      styleLink.setAttribute('data-hulk-qq-css', 'true');
      doc.head.appendChild(styleLink);
    }

    initInDocument(doc);

    if (!doc.defaultView || doc.defaultView.__hulkQqWrapped) return true;
    doc.defaultView.__hulkQqWrapped = true;
    return true;
  }

  function scanIframes() {
    document.querySelectorAll('iframe').forEach(function (iframe) {
      var src = iframe.getAttribute('src') || '';
      if (src.indexOf(HULK_FORM_ID) === -1 && !iframe.className.match(/hulk/i)) return;

      iframe.addEventListener('load', function () {
        injectIntoIframe(iframe);
      });

      injectIntoIframe(iframe);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanIframes);
  } else {
    scanIframes();
  }

  var observer = new MutationObserver(scanIframes);
  observer.observe(document.body, { childList: true, subtree: true });
})();
